import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PlatformHeaderService } from './components/platform-header/platform-header.service';
import { AppLoaderService } from './shared/services/app-loader.service';
import { AppModalService } from './shared/services/app-modal.service';
import { AppToastService, AppToastState } from './shared/services/app-toast.service';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('modalHost', { read: ViewContainerRef })
  private modalHost?: ViewContainerRef;

  hideAppHeader = false;
  showPlatformHeader = false;
  activeToast: AppToastState | null = null;
  isLoaderVisible = false;

  private toastSub?: Subscription;
  private loaderSub?: Subscription;

  constructor(
    private router: Router,
    private platformHeaderService: PlatformHeaderService,
    private appToastService: AppToastService,
    private appModalService: AppModalService,
    private appLoaderService: AppLoaderService,
  ) {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(() => this.updateLayoutState());

    this.updateLayoutState();
  }

  ngOnInit(): void {
    this.toastSub = this.appToastService.toast$.subscribe(toast => {
      this.activeToast = toast;
    });
    this.loaderSub = this.appLoaderService.visible$.subscribe(visible => {
      this.isLoaderVisible = visible;
    });
  }

  ngAfterViewInit(): void {
    if (this.modalHost) {
      this.appModalService.registerHost(this.modalHost);
    }
  }

  ngOnDestroy(): void {
    this.toastSub?.unsubscribe();
    this.loaderSub?.unsubscribe();
  }

  onToastDismiss(): void {
    this.appToastService.dismiss();
  }

  private updateLayoutState(): void {
    let route = this.router.routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    this.hideAppHeader = route.snapshot.data['hideAppHeader'] === true;
    this.showPlatformHeader = this.platformHeaderService.shouldShowHeader(this.router.url);
  }
}
